export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    getTagList: function getTagList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/tag/get",
        method: "get",
        params: data
      });
    },
    addTag: function addTag() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/tag/add",
        method: "post",
        data: data
      });
    },
    updateTag: function updateTag() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/tag/update",
        method: "post",
        data: data
      });
    },
    getTagType: function getTagType() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/tag/getTagType",
        method: "get",
        params: data
      });
    },
    updateTagStatus: function updateTagStatus() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/tag/updateStatus",
        method: "post",
        data: data
      });
    }
  };
});